import { Container, Stack, ThemeProvider } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { getSafeAreaPaddings, getTheme } from "@src/appV2/redesign/system/ui-theme";
import { type ReactElement } from "react";

import { PageWrapper } from "../redesign/components/PageWrapper";

export function E2ELoadingPage(): ReactElement {
  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper
        sx={{
          background: (theme) => theme.palette.intent?.neutral.gradient,
          ...getSafeAreaPaddings({ bottom: true, fallbackBottom: "24px" }),
          paddingX: 2,
        }}
      >
        <Container
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Stack
            spacing={10}
            alignItems="center"
            textAlign="center"
            sx={{
              flex: 1,
              justifyContent: "center",
              mb: 3,
            }}
          >
            <Stack spacing={4}>
              <Text semibold variant="h3">
                Hang in there!
              </Text>
              <Text variant="body1" sx={{ color: (theme) => theme.palette.text.secondary }}>
                We&apos;re setting up your test scenario...
              </Text>
            </Stack>
          </Stack>
        </Container>
      </PageWrapper>
    </ThemeProvider>
  );
}
